import React from 'react';
import { FormGroup, Label } from 'reactstrap';
import { ReactSearchAutocomplete } from 'react-search-autocomplete';
import { EntityId } from '@Models';
import { FormattedMessage } from 'react-intl';

const ReduxFormInput: React.FC = (field: any) => {

  const formatResult = (item: EntityId<number>) => {
    return (
      <div>
        <span style={{ display: 'block', textAlign: 'left' }}>{item.name}</span>
      </div>
    );
  };
  return (
    <FormGroup row={false}>
      {field.label && (<Label><FormattedMessage {...field.label} /></Label>)}
      <ReactSearchAutocomplete<EntityId<number>>
        items={field.payloads}
        onSelect={field.handleOnSelect}
        autoFocus
        formatResult={formatResult}
      />
      {field.meta.touched && field.meta.error && (
        <p className="text-danger"><FormattedMessage id={field.meta.error} /></p>
      )}
    </FormGroup>
  );
};

export default ReduxFormInput;
